import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=0f8f5964&scoped=true&"
import script from "./StatisticsView.vue?vue&type=script&lang=ts&"
export * from "./StatisticsView.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=0f8f5964&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8f5964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
